module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"be-NL":{"enter_address":"Vul het adres hier in","not_found":"Het adres staat niet in de lijst"},"be-EN":{"enter_address":"Enter address here","not_found":"The address is not in the list"},"be-FR":{"enter_address":"Entrer une addresse ici","not_found":"L\u0027adresse n\u0027est pas dans la liste"}}')
  delete Component.options._Ctor
}
